module.exports = __webpack_public_path__ + "img/crop_info_left_right.6642ff0f.png";